var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ApolloMutation',{attrs:{"mutation":(gql) => _vm.removeCouponMutation,"variables":{
    id: _vm.orderId,
  }},on:{"done":_vm.onDone},scopedSlots:_vm._u([{key:"default",fn:function({mutate, loading}){return [_c('ekitabu-button',{staticClass:"remove-coupon-btn",attrs:{"icon":"","x-small":"","disabled":loading,"title":_vm.$t('checkout.removeCoupon'),"ripple":false},on:{"click":mutate}},[(loading)?_c('spinner-icon',{attrs:{"size":12}}):_c('close-icon',{attrs:{"size":12}})],1)]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }